module.exports = __webpack_public_path__ + "img/coupon_greenOther.b5fd9886.webp";